import { useState, useEffect } from "react";
import { API } from "aws-amplify";

import { useReactiveVar } from "@apollo/client";
import { Routes, Route } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { useQuery, gql, useApolloClient } from "@apollo/client";

import { RequireAuth, UnAuthLayout } from "./layout";

import {
  ExternalPartnerLayout,
  EntityLayout,
  AdminLayout,
} from "./layout/subLayout";
import iterateRoute from "./function/getRoute";
import entityModules from "./modules/entityModules";
import privateModules from "./modules/privateModules";
import publicModules from "./modules/publicModules";
import systemAdminModules from "./modules/systemAdminModules";
import externalPartnerModules from "./modules/externalPartnerModules";
import { Dashboard } from "./pages";
import AuthPage from "./component/auth/AuthPage";
import useCurrentUser from "./function/hook/useCurrentUser";
import { userVar, userEntityRelationVar } from "./client/cache";

import "./globalCss.css";
import { toChinaDateString } from "./lib/chinaDate";


function AuthCountDown() {
  const countDownReset = useCurrentUser();
  return (
    <p
      style={{
        position: "absolute",
        top: 100,
        right: 0,
        // color: "red",
      }}
    >
      {/* Session Timeout in {countDownReset} seconds */}
    </p>
  );
}

function App() {
  const user = useReactiveVar(userVar);
  const client = useApolloClient();

  useEffect(() => {
    async function func() {
      if (user === "loading") return;

      console.log({ user });

      const res = await fetch("https://ipinfo.io/json?token=cbead905817ecd");
      const data = (await res?.json()) || {};
      const {
        city,
        country,
        hostname,
        loc,
        org,
        postal,
        timezone,
        ip,
        region,
      } = data;
      const timeString = toChinaDateString();

      const d = {
        timeString,
        city,
        country,
        hostname,
        loc,
        org,
        postal,
        ip,
        region,
        userID: user?.id,
        timezone,
        type: "LOGIN",
      };

      if (Object.keys(data).length > 0) {
        const res = await API.post("iSupplyAPI", "/public", {
          body: {
            operation: "CREATE_LOG",
            data: d,
          },
        });
      }
    }
    func();

    // Fetch the user's IP address
  }, [user, client]);

  // const countDownReset = useCurrentUser();

  const userEntityRelation = useReactiveVar(userEntityRelationVar);

  // if (user === "loading" || userEntityRelation === "loading") return null;

  const isAuthenticated = !!user?.sub;
  const { entityID, entityType, userRole } = userEntityRelation;

  const retrivedRoutesFromModules = (modules) => {
    const route = modules
      .filter((x) => x.route)
      ?.reduce((a, v) => {
        a[v.path] = v.route;
        return a;
      }, {});

    return iterateRoute({
      entityType,
      userRole,
      isAuthenticated,
      entityID,
      route,
    });
  };

  // NOT SURE WHAT GLOBALSYLES IS DOING HERE
  return (
    <>
      {/* <GlobalStyles styles={{ margin: 0, padding: 0, listStyle: "none" }} /> */}
      <CssBaseline />

      <Routes>
        <Route element={<UnAuthLayout />}>
          {retrivedRoutesFromModules(publicModules)}
        </Route>

        <Route path="auth" element={<AuthPage />} />
        <Route path="ebp/:entityID" element={<ExternalPartnerLayout />}>
          {retrivedRoutesFromModules(externalPartnerModules)}
        </Route>
        <Route path="/cloud" element={<RequireAuth />}>
          <Route index element={<Dashboard />} />
          {retrivedRoutesFromModules(privateModules)}
          <Route path="admin-console" element={<AdminLayout />}>
            {retrivedRoutesFromModules(systemAdminModules)}
          </Route>
          <Route path=":entityID" element={<EntityLayout />}>
            {retrivedRoutesFromModules(entityModules)}
          </Route>
        </Route>
        <Route path="*" element={<p>nothing</p>} />
      </Routes>
      <AuthCountDown />
    </>
  );
}

export default App;
